import { Product } from './types';

export const petProducts: Product[] = [
  {
    id: 'GF1',
    numericId: 501,
    name: 'GF1',
    description: 'Автоматическое устройство для кормления питомцев с дистанционным управлением',
    price: '7,199₽',
    image: '/images/pet/scene/GF1/宠物喂食器主图.jpg',
    cardImage: '/images/pet/GF1.png',
    gallery: [
      {
        src: '/images/pet/scene/GF1/宠物喂食器场景图5.jpg',
      },
      {
        src: '/images/pet/scene/GF1/宠物喂食器场景图2.jpg',
      },
      {
        src: '/images/pet/scene/GF1/宠物喂食器场景图3.jpg',
      },
      {
        src: '/images/pet/scene/GF1/宠物喂食器场景图4.jpg',
      }
    ],
     "features": [
        "WiFi连接，通过应用程序远程控制",
        "一键喂食，喂食计划，缺粮提醒",
        "可拆卸和可清洗设计",
        "所有材料均为食品级"
      ],
        specifications: {
        '尺寸': '178mm * 177mm * 335mm',
        '重量': '1761g',
        '容量': '4L',
        '颜色': '白色',
        '材质': 'ABS + SUS304',
        '适用宠物类型': '猫咪以及小型和中型犬'
        }
  },
  {
    id: 'GW1',
    numericId: 502,
    name: 'GW1',
    description: 'Умный фонтан для питомцев для поддержания свежести воды',
    price: '3,899₽',
    image: '/images/pet/scene/GW1/GW1_main.jpg',
    cardImage: '/images/pet/GW1.png',
    gallery: [
      {
        src: '/images/pet/scene/GW1/1.jpg',
      },
      {
        src: '/images/pet/scene/GW1/2.jpg',
      },
      {
        src: '/images/pet/scene/GW1/3.jpg',
      },
      {
        src: '/images/pet/scene/GW1/4.jpg',
      }
    ],
    features: [
        "无水自动关闭，静音泵",
        "电源：USB充电和电池（4000毫安时）",
        "易于拆卸和清洁",
        "3种工作模式：感应，定时和连续"
    ],
    specifications: {
        "尺寸": "210mm * 210mm * 142mm",
        "重量": "650g",
        "容量": "3.2L",
        "颜色": "白色",
        "材质": "ABS",
        "适用宠物类型": "猫咪以及小型和中型犬"
    }
  },
  {
    id: 'PD1',
    numericId: 503,
    name: 'PD1',
    description: 'Низкошумное сушильное устройство для домашних животных',
    price: '33,999₽',
    image: '/images/pet/scene/PD1/PD1主图.jpg',
    cardImage: '/images/pet/PD1.png',
    gallery: [
      {
        src: '/images/pet/scene/PD1/PD1场景图1.jpg',
      },
      {
        src: '/images/pet/scene/PD1/PD1场景图2.jpg',
      },
      {
        src: '/images/pet/scene/PD1/PD1场景图3.jpg',
      },
      ],
     "features": [
        "温和烘干技术，不伤害宠物毛发",
        "超低噪音设计，减少宠物紧张",
        "多温度设置，适合不同宠物需求"
      ],
        specifications: {
       '尺寸': '450mm * 350mm * 500mm',
        '重量': '5800g',
        "额定功率": "1200W",
        "颜色": "白色",
        "材质": "ABS + 不锈钢",
        "温度范围": "30-70°C"
        }
  },
  {
    id: 'CT1',
    numericId: 504,
    name: 'CT1',
    description: 'Умный автоматический очищающийся лоток для кошек',
    price: '36,999₽',
    image: '/images/pet/scene/CT1/CT1主图.jpg',
    cardImage: '/images/pet/CT1.png',
    gallery: [
      {
        src: '/images/pet/scene/CT1/CT1场景图1.jpg',
      },
      {
        src: '/images/pet/scene/CT1/CT1场景图2.jpg',
      },
      {
        src: '/images/pet/scene/CT1/CT1场景图3.jpg',
      },
      ],
     "features": [
        "自动清洁系统，省时省力",
        "有效除臭设计，保持室内空气清新",
        "智能感应技术，识别猫咪使用情况"
      ],
        specifications: {
        "尺寸": "520mm * 480mm * 420mm",
        "重量": "4500g",
        "电源": "220V/50Hz",
        "容量": "5L",
        "颜色": "灰色",
        "材质": "ABS + PP"
        }
  },
  {
    id: 'NM1',
    numericId: 505,
    name: 'NM1',
    description: 'Многофункциональное устройство для ухода за питомцами',
    price: '16,999₽',
    image: '/images/pet/scene/NM1/NM1主图.jpg',
    cardImage: '/images/pet/NM1.png',
    gallery: [
      {
        src: '/images/pet/scene/NM1/NM1场景图1.jpg',
      },
      {
        src: '/images/pet/scene/NM1/NM1场景图2.jpg',
      },
      {
        src: '/images/pet/scene/NM1/NM1场景图3.jpg',
      },
      ],
     "features": [
        "温和按摩功能，促进血液循环",
        "可调节强度，适合不同宠物需求",
        "人体工学设计，使用舒适"
      ],
        specifications: {
        "尺寸": "180mm * 80mm * 50mm",
        "重量": "350g",
        "工作时间": "4h",
        "充电时间": "2h",
        "颜色": "白色",
        "材质": "ABS + 硅胶"
        }
  },
  {
    id: 'PC1',
    numericId: 506,
    name: 'PC1',
    description: 'Интеллектуально разработанный инструмент для ухода за шерстью питомцев',
    price: '8,399₽',
    image: '/images/pet/scene/PC1/PC1主图.jpg',
    cardImage: '/images/pet/PC1.png',
    gallery: [
      {
        src: '/images/pet/scene/PC1/PC1场景图1.jpg',
      },
      {
        src: '/images/pet/scene/PC1/PC1场景图2.jpg',
      },
      {
        src: '/images/pet/scene/PC1/PC1场景图3.jpg',
      },
      ],
     "features": [
        "高效去除浮毛，减少掉毛问题",
        "舒适设计，不伤害宠物皮肤",
        "易于清洁维护"
      ],
        specifications: {
        "尺寸": "175mm * 90mm * 40mm",
        "重量": "120g",
        "材质": "ABS + 不锈钢",
        "颜色": "白色",
        "适用宠物类型": "猫咪和所有类型的犬"
        }
  },
  {
    id: 'GS1',
    numericId: 507,
    name: 'GS1',
    description: 'Профессиональный инструмент для стрижки домашних животных',
    price: '2,899₽',
    image: '/images/pet/scene/GS1/GS1主图.jpg',
    cardImage: '/images/pet/GS1.png',
    gallery: [
      {
        src: '/images/pet/scene/GS1/GS1场景图1.jpg',
      },
      {
        src: '/images/pet/scene/GS1/GS1场景图2.jpg',
      },
      {
        src: '/images/pet/scene/GS1/GS1场景图3.jpg',
      },
      ],
     "features": [
        "低噪音设计，减少宠物紧张",
        "可调节刀头，适合不同毛发长度",
        "无线设计，使用灵活"
      ],
        specifications: {
        "尺寸": "180mm * 45mm * 45mm",
        "重量": "300g",
        "电池容量": "2000mAh",
        "工作时间": "120min",
        "充电时间": "3h",
        "材质": "ABS + 不锈钢刀头"
        }
  },
  {
    id: 'GC1',
    numericId: 508,
    name: 'GC1',
    description: 'Эффективный инструмент для удаления шерсти питомцев',
    price: '729₽',
    image: '/images/pet/scene/GC1/GC1主图.jpg',
    cardImage: '/images/pet/GC1.png',
    gallery: [
      {
        src: '/images/pet/scene/GC1/GC1场景图1.jpg',
      },
      {
        src: '/images/pet/scene/GC1/GC1场景图2.jpg',
      },
      {
        src: '/images/pet/scene/GC1/GC1场景图3.jpg',
      },
      ],
     "features": [
        "人体工学设计，使用舒适",
        "有效去除浮毛和打结",
        "适合各种类型的宠物毛发"
      ],
        specifications: {
        "尺寸": "170mm * 85mm * 30mm",
        "重量": "85g",
        "材质": "PP + 不锈钢针齿",
        "颜色": "绿色",
        "适用宠物类型": "短毛和长毛宠物"
        }
  },
  {
    id: 'NC1',
    numericId: 509,
    name: 'NC1',
    description: 'Безопасный и эффективный инструмент для стрижки когтей питомцев',
    price: '999₽',
    image: '/images/pet/scene/NC1/NC1主图.jpg',
    cardImage: '/images/pet/NC1.png',
    gallery: [
      {
        src: '/images/pet/scene/NC1/NC1场景图1.jpg',
      },
      {
        src: '/images/pet/scene/NC1/NC1场景图2.jpg',
      },
      {
        src: '/images/pet/scene/NC1/NC1场景图3.jpg',
      },
      ],
     "features": [
        "精准剪切，避免伤害",
        "防滑手柄，操作稳定",
        "适合各种大小的宠物"
      ],
        specifications: {
        "尺寸": "140mm* 55mm *15mm",
        "重量": "75g",
        "材质": "不锈钢 + 橡胶手柄",
        "颜色": "银色/绿色",
        "适用宠物类型": "猫咪和犬类"
        }
  },
  {
    id: 'DH1',
    numericId: 510,
    name: 'DH1',
    description: 'Удобное и безопасное устройство для выгула питомцев',
    price: '2,499₽',
    image: '/images/pet/scene/DH1/DH1主图.jpg',
    cardImage: '/images/pet/DH1.png',
    gallery: [
      {
        src: '/images/pet/scene/DH1/DH1场景图1.jpg',
      },
      {
        src: '/images/pet/scene/DH1/DH1场景图2.jpg',
      },
      {
        src: '/images/pet/scene/DH1/DH1场景图3.jpg',
      },
      ],
     "features": [
        "透气材料，佩戴舒适",
        "可调节尺寸，适合不同体型",
        "反光设计，夜间安全"
      ],
        specifications: {
        "尺寸": "可调节，适合胸围20-60cm",
        "重量": "120g",
        "材质": "尼龙 + 网眼布",
        "颜色": "绿色",
        "适用宠物类型": "小型至中型犬"
        }
  },
  {
    id: 'TR1',
    numericId: 511,
    name: 'TR1',
    description: 'Высококачественный поводок для выгула питомцев',
    price: '2,999₽',
    image: '/images/pet/scene/TR1/TR1主图.jpg',
    cardImage: '/images/pet/TR1.png',
    gallery: [
      {
        src: '/images/pet/scene/TR1/TR1场景图1.jpg',
      },
      {
        src: '/images/pet/scene/TR1/TR1场景图2.jpg',
      },
      {
        src: '/images/pet/scene/TR1/TR1场景图3.jpg',
      },
      ],
     "features": [
        "耐用材质，承受拉力强",
        "合理长度，控制得当",
        "舒适手柄，长时间使用不疲劳"
      ],
        specifications: {
        "长度": "1.5m（可伸缩至3m）",
        "重量": "250g",
        "材质": "尼龙 + ABS",
        "承重": "50kg",
        "颜色": "绿色",
        "适用宠物类型": "小型至中型犬"
        }
  },
  {
    id: 'GB1',
    numericId: 512,
    name: 'GB1',
    description: 'Портативный дозатор пакетов для уборки за питомцами',
    price: '449₽',
    image: '/images/pet/scene/GB1/GB1主图.jpg',
    cardImage: '/images/pet/GB1.png',
    gallery: [
      {
        src: '/images/pet/scene/GB1/GB1场景图1.jpg',
      },
      {
        src: '/images/pet/scene/GB1/GB1场景图2.jpg',
      },
      {
        src: '/images/pet/scene/GB1/GB1场景图3.jpg',
      },
      ],
     "features": [
        "便携设计，易于携带",
        "大容量，减少更换频率",
        "防水材质，适合各种天气"
      ],
        specifications: {
        "尺寸": "85mm  * 45mm  * 45mm ",
        "重量": "60g",
        "容量": "可装15个袋子",
        "材质": "ABS + 硅胶",
        "颜色": "绿色",
        "适用场景": "户外遛宠物"
        }
  },
  {
    id: 'Snail Car',
    numericId: 513,
    name: 'Snail Car',
    description: 'Веселая интерактивная игрушка для домашних животных',
    price: '1,999₽',
    image: '/images/pet/scene/Snail_Car/蜗牛跑跑车主图.jpg',
    cardImage: '/images/pet/Snail_Car.png',
    gallery: [
      {
        src: '/images/pet/scene/Snail_Car/蜗牛跑跑车场景图1.jpg',
      },
      {
        src: '/images/pet/scene/Snail_Car/蜗牛跑跑车场景图2.jpg',
      },
      {
        src: '/images/pet/scene/Snail_Car/蜗牛跑跑车场景图3.jpg',
      },
      ],
     "features": [
        "安全材料，无毒无害",
        "有趣设计，增加互动乐趣",
        "耐咬耐用，经久耐玩"
      ],
        specifications: {
        "尺寸": "120mm * 80mm  * 60mm ",
        "重量": "150g",
        "材质": "TPR环保材料",
        "颜色": "多彩",
        "适用宠物类型": "小型犬和猫"
        }
  }
]; 